import mg1 from './images/psc1.jpg'
import mg2 from './images/psc2.jpg'
import mg3 from './images/psc3.jpg'
import mg4 from './images/psc4.webp'
import mg5 from './images/psc5.jpg'
import mg6 from './images/psc6.jpg'
import mg7 from './images/psc7.jpg'
import mg8 from './images/psc8.jpg'
import mg9 from './images/psc9.jpg'
import mg10 from './images/psc10.jpg'
import mg11 from './images/psc11.webp'
import mg12 from './images/psc12.webp'
import mg13 from './images/psc13.webp'
import mg14 from './images/psc14.jpg'
import mg15 from './images/psc15.webp'
import mg16 from './images/psc16.jpg'
import mg17 from './images/psc17.webp'
import mg18 from './images/psc18.jpg'

import mg19 from './images/land.jpg'
import mg20 from './images/agriculture land.jpg'
import mg21 from './images/commercial building.jpg'
import mg22 from './images/residential building.jpg'
import mg23 from './images/villa.jpg'
import mg24 from './images/duplix house.jpg'
import mg25 from './images/apartment.jpg'
import mg26 from './images/shop.jpg'
import mg27 from './images/office.jpg'

import mg28 from './images/USACAR1.jpeg'
import mg29 from './images/GERMANCAR1.jpg'
import mg30 from './images/JAPANCAR1.jpg'
import mg34 from './images/CHINACAR1.jpg'
import mg35 from './images/KOREACAR1.jpg'
import mg36 from './images/BRITISHCAR1.jpg'

import mg31 from './images/abaia1.jpg'
import mg32 from './images/furniture1.jpg'
import mg33 from './images/stocks1.jpg'

export const sliderItems = [
    {
      id: 1,
      img: mg31,
      title: "SUMMER SALE",
      desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
      bg: "f5fafd",
    },
    {
      id: 2,
      img:mg32,
      title: "AUTUMN COLLECTION",
      desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
      bg: "f5fafd",
    },
    {
      id: 3,
      img: mg33,
      title: "LOUNGEWEAR LOVE",
      desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
      bg: "f5fafd",
    },
  ];

  export const realEstateSlider = [
    {
      id: 1,
      img: mg31,   // replace with your real estate hero images
      title: "FIND YOUR DREAM HOME",
      desc: "Browse apartments, villas, lands, and more.",
      bg: "f5fafd",
    },
    {
      id: 2,
      img: mg32,
      title: "PREMIUM VILLAS",
      desc: "Luxury living with modern architecture.",
      bg: "f5fafd",
    },
    {
      id: 3,
      img: mg33,
      title: "COMMERCIAL SPACES",
      desc: "Shops, offices, and investment opportunities.",
      bg: "f5fafd",
    },
  ];



  // Each entry becomes a clickable tile on the home page under the Cars tab.
  // Clicking navigates to /cars/<carproducer> — must match the country key
  // used in NewCar.js's carOptions.
  export const Carcategory = [
    {
      id: 1,
      img: mg28,
      title: "American Cars",
      carproducer: "USA"
    },
    {
      id: 2,
      img: mg29,
      title: "German Cars",
      carproducer: "Germany"
    },
    {
      id: 3,
      img: mg30,
      title: "Japanese Cars",
      carproducer: "Japan"
    },
    {
      id: 4,
      img: mg34,
      title: "Chinese Cars",
      carproducer: "China"
    },
    {
      id: 5,
      img: mg35,
      title: "Korean Cars",
      carproducer: "Korea"
    },
    {
      id: 6,
      img: mg36,
      title: "British Cars",
      carproducer: "UK"
    },
  ];


  export const RealEstateCategory = [
    {
      id: 1,
      img: mg19,
      title: "Lands",
      propertytype: "Land"
    },
    {
      id: 2,
      img: mg20,
      title: "Agriculture Lands",
      propertytype: "Agriculture Land"
    },
    {
      id: 3,
      img: mg23,
      title: "Villas",
      propertytype: "Villa"
    },
    {
    id: 4,
      img: mg24,
      title: "Duplex Houses",
      propertytype: "Duplex House"
    },
    {
      id: 5,
      img: mg25,   // replace with your real estate images
      title: "Apartments",
      propertytype: "Apartment"
    },


    {
      id: 6,
      img: mg21,
      title: "Commercial Buildings",
      propertytype: "Commercial Building"
    },

    {
      id: 7,
      img: mg22,
      title: "Residential Buildings",
      propertytype: "Residential Building"
    },

    {
      id: 8,
      img: mg27,
      title: "Offices",
      propertytype: "Office"
    },
    {
      id: 9,
      img: mg26,
      title: "Shops",
      propertytype: "Shop"
    },
  ];


  export const popularProducts = [
    {
      id:1,
      img:mg7,
    },
    {
      id:2,
      img:mg8,
    },
    {
      id:3,
      img:mg9,
    },
    {
      id:4,
      img:mg10,
    },
    {
      id:5,
      img:mg11,
    },
    {
      id:6,
      img:mg12,
    },
    {
      id:7,
      img:mg13,
    },
    {
      id:8,
      img:mg14,
    },
    {
      id:9,
      img:mg15,
    },
    {
      id:10,
      img:mg16,
    },
    {
      id:11,
      img:mg17,
    },
    {
      id:12,
      img:mg18,
    },
  ]
